<template>
    <div>
        <!--搜索栏-->
        <el-row type="flex" class="row-bg p-10 mt-10 bg-lightgarg"  justify="space-between">
            <el-col :span="4"  class="mr-10">
                <el-select v-model="selectTripValue" clearable filterable  placeholder="Trip" :loading="loading" loading-text="loading..." no-match-text="No data" no-data-text="No data"  @change="tripSelectList" @visible-change="showTripList" style="width: 100%;">
                    <el-option v-for="item in options" :label="item.name" :value="item.id" :key="item.id"></el-option>
                </el-select>
            </el-col>
            <el-col :span="5">
                <el-input placeholder="Search anything about users"  class="input-setMaxWidth" v-model="keywords" @keyup.enter.native="handleIconClick" >
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="handleIconClick"></i>
                </el-input>
            </el-col>
            <el-col :span="15">
                <div style="text-align: right">
                    <a :href="require('../../assets/epq_forms1-13.docx')">
                        <el-button type="primary"><i class="icon ion-android-download"></i> EPQ offline document</el-button>
                    </a>
                </div>
            </el-col>
        </el-row>

        <!--下方表格-->
        <el-table empty-text="No data" :data="MyStudents" style="width: 100%" v-loading="loading"  :element-loading-text="loadingText" @expand-change="getExpand" class="mt-20" :expand-row-keys="expandRowKeys" :row-key="getRowKey">
            <el-table-column type="expand" prop="id">
                <template slot-scope="props">
                    <el-tabs type="border-card" @tab-click="getStuReport($event, props.$index, props.row)">
                        <el-tab-pane label="EPQ" v-loading="props.row.loadingReport" element-loading-text="loading...">
                            <el-form label-position="left" inline class="demo-table-expand">
                                <el-form-item v-for="(skill, index) in MyStudents[props.$index].reportC.skillList" :label="skill.abbr" :key="index">
                                    <el-button-group class="pt-7" v-for="(page,index) in skill.pageList" :key="index">
                                        <el-button :class="page.confirmed == null ? 'info' : page.confirmed ? 'success' : 'primary'" plain class="p-5" icon="el-icon-edit-outline" @click="showPage (skill, page.page, page.id,props.$index,'epq')" :key="index"></el-button>
                                        <router-link class="white mr-10" target="_blank"  :to="{path: 'evidence', query: { studentId: props.row.id, studentName: (props.row.displayName +' '+ props.row.givenName +' '+ props.row.familyName), pageId: page.id, skillAbbr: skill.abbr, skillName: skill.name, pageName: page.page, reportId: props.row.reportC.id, reportName: props.row.reportC.category, reportIndex: $route.path }}" append>
                                            <el-button plain class="p-evidence"><i class="icon ion-folder" :class="page.evidenceConfirmed == null ? 'info' :page.evidenceConfirmed ? 'success' : 'primary'"></i></el-button>
                                        </router-link>
                                    </el-button-group>
<!--                                    <el-progress :percentage="skill.percentage" color="#13ce66" style="width:169.13px"></el-progress>-->
<!--                                    <el-button type="text" v-for="(page,index) in skill.pageList" v-bind:class="page.confirmed?'icon ion-checkmark-round success':'icon ion-close-round dark'"-->
<!--                                               @click="showPage (skill, page.page, page.id,props.$index,'cope')" :key="index"></el-button>-->
<!--                                    <router-link class="white" :to="{ path: 'evidence', query: { studentId: props.row.id, studentName: (props.row.displayName +' '+ props.row.givenName +' '+ props.row.familyName),  skillId: skill.id, skillAbbr: skill.abbr, skillName: skill.name, reportId: props.row.reportC.id, reportName: props.row.reportC.category, reportIndex: $route.path }}" append>-->
<!--                                        <i class="icon ion-folder primary ml-10"></i>-->
<!--                                    </router-link>-->
                                </el-form-item>
                                <el-form-item class="full-width">
                                    <el-button type="primary" size="mini" @click="download(props.row)">
                                        <i class="icon ion-shuffle mt-none"></i> Generate Report (PDF)
                                    </el-button>
                                    <el-button type="warning" size="mini" @click="downloadDocx(props.row)">
                                      <i class="icon ion-shuffle mt-none"></i> Generate Report (DOCX)
                                    </el-button>
                                    <el-button type="success" size="mini" @click="preview(props.row)">
                                      <i class="icon el-icon-picture-outline"></i> Report Preview
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane label="LOG" v-loading="props.row.loadingReport" element-loading-text="loading...">
                            <el-form label-position="left" inline class="demo-table-expand">
                                <el-form-item v-for="(skill, index) in MyStudents[props.$index].report.skillList" :label="skill.abbr" :key="index" class="log">
                                    <el-button-group class="pt-7" v-for="(page,index) in skill.pageList" :key="index">
                                        <el-button plain class="p-5" icon="el-icon-edit-outline" @click="showPage (skill, page.page, page.id,props.$index,'log')" :key="index"></el-button>
                                    </el-button-group>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                    </el-tabs>
                </template>
            </el-table-column>
            <el-table-column  label="Name" width="220">
                <template slot-scope="scope">
                    <span>{{scope.row.displayName + ' - ' + scope.row.givenName + '  ' +  scope.row.familyName}}</span>
                    <router-link :to="{ path: '/notification', query: { studentId: scope.row.id, studentName:(scope.row.displayName + ' - ' + scope.row.givenName + '  ' +  scope.row.familyName)}}"  target="_blank">
                        <el-badge :value="role ==='teacher' || role === 'ta'?scope.row.notificationCount:0" :hidden="scope.row.notificationCount===0"></el-badge>
                    </router-link>
                </template>
            </el-table-column>
            <el-table-column label="Affiliation" prop="school" min-width="190"></el-table-column>
            <el-table-column label="deadline1" prop="deadline1" min-width="190"></el-table-column>
            <el-table-column label="deadline2" prop="deadline2" min-width="190"></el-table-column>
            <el-table-column label="Terms" prop="trip"></el-table-column>
            
<!--            <el-table-column label="Actions" width="180" align="center">-->
<!--                <template slot-scope="scope">-->
<!--                    &lt;!&ndash;<el-button type="primary" plain size="mini" @click="editAopeSkill(scope.row, scope.$index)">AoPE Skills</el-button>&ndash;&gt;-->
<!--                    <el-button type="info" size="mini" icon="el-icon-close" @click="Editstudent(scope.row)"></el-button>-->
<!--                </template>-->
<!--            </el-table-column>-->
        </el-table>
        <!--分页符-->
        <div class="text-center mt-20 mb-50">
            <el-pagination layout="prev, pager, next" :page-size="size" :current-page="currentPageTable" :page-count="totalPages"
                           @current-change="pageCurrentChange">
            </el-pagination>
        </div>

        <!--修改学生信息弹窗-->
        <el-dialog title="Edit User" :visible.sync="Editdialog" customClass="dialogStyle">
            <el-form :model="editform" :rules="editrules" ref="editform" label-width="145px">
                <el-form-item label="Email Address" prop="Eemail">
                    <el-input placeholder="Email Address" v-model="editform.Eemail" @change="isDirty = true"></el-input>
                </el-form-item>
                <el-form-item label="Change Password" prop="checked" class="form-item-default">
                    <el-checkbox v-model="checked" @change="changePass" >Change Password</el-checkbox>
                </el-form-item>

                <template v-if="willshow">
                    <el-form-item label="Password" prop="Epassword">
                        <el-input type="password" v-model="editform.Epassword" placeholder="Password should contain 8 to 20 characters."></el-input>
                    </el-form-item>
                    <el-form-item label="Confirm Password" prop="EconfirmPassword">
                        <el-input type="password" v-model="editform.EconfirmPassword" placeholder="Confirm Password" ></el-input>
                    </el-form-item>
                </template>
                <el-form-item label="Given Name" prop="EgivenName">
                    <el-input v-model="editform.EgivenName" placeholder="Given Name" @change="isDirty = true"></el-input>
                </el-form-item>
                <el-form-item label="Family Name" prop="EfamilyName">
                    <el-input v-model="editform.EfamilyName" placeholder="Family Name" @change="isDirty = true"></el-input>
                </el-form-item>
                <el-form-item label="Display Name" prop="EdisplayName">
                    <el-input v-model="editform.EdisplayName" placeholder="Display Name" @change="isDirty = true"></el-input>
                </el-form-item>
                <el-form-item label="School" prop="Eschool">
                    <el-input v-model="editform.Eschool" placeholder="Affiliation" @change="isDirty = true"></el-input>
                </el-form-item>
                <el-form-item label="Trips" prop="trip">
                    <el-select filterable no-match-text="No data" no-data-text="No data" v-model="dialogtripid"  placeholder="Please select trip"  @change="isTripDirty = true" visible-change="getTrip">
                        <el-option v-for="(item, index) in options" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Mobile Phone" prop="EmobilePhone">
                    <el-input v-model="editform.EmobilePhone" placeholder="Mobile Phone" @change="isDirty = true"></el-input>
                </el-form-item>
                <el-form-item label="Father Phone" prop="EfatherPhone">
                    <el-input v-model="editform.EfatherPhone" placeholder="Father Phone" @change="isDirty = true"></el-input>
                </el-form-item>
                <el-form-item label="Mother Phone" prop="EmotherPhone">
                    <el-input v-model="editform.EmotherPhone" placeholder="Mother Phone" @change="isDirty = true"></el-input>
                </el-form-item>
                <el-form-item label="Deadline1" prop="EDeadline1">
                    <el-date-picker v-model="editform.EDeadline1" type="date" :picker-options="pickerOptions" placeholder="Please select deadline"  @change="isDirty = true"></el-date-picker>
                </el-form-item>
                <el-form-item label="Deadline2" prop="EDeadline2">
                    <el-date-picker v-model="editform.EDeadline2" type="date" :picker-options="pickerOptions" placeholder="Please select deadline"  @change="isDirty = true"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="Editdialog = false">Close</el-button>
                <el-button type="primary" @click="submitedit('editform')" :loading="saveBtnIsLoading">Save</el-button>
            </div>
        </el-dialog>

        <!-- 下载报告弹出的dialog -->
        <el-dialog title="Generate Report" :visible.sync="showReportDialog">
            <el-form inline v-model="reportDialogParam" label-position="right" label-width="130px">
                <el-row  style="margin-bottom:15px;color:#C0C4CC;">
                    <el-col>
                        <span>This will be used to sign the check list and all the pages, leave empty if you don't want to sign.</span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="Assessor">
                            <el-input v-model="reportDialogParam.assessor"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="Internal Moderator">
                            <el-input v-model="reportDialogParam.moderator"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showReportDialog = false">Cancel</el-button>
                <el-button type="primary" @click="download(student,  reportDialogParam.category)" :loading="saveBtnIsLoading">OK</el-button>
            </div>
        </el-dialog>

        <!--配置学生aope技能弹窗-->
        <el-dialog
                :title="configSkillTitle"
                v-loading="configSkillDialogLoading"
                :visible.sync="configSkillDialog">
            <el-checkbox-group
                    :max="3"
                    :min="1"
                    @change="changeCheckedSkill"
                    v-model="checkedSkillsName">
                <div class="configAope">
                    <el-checkbox v-for="skill in allAopeSkills" :label="skill.name" :key="skill.id">{{skill.name}}</el-checkbox>
                </div>
            </el-checkbox-group>
            <span slot="footer" class="dialog-footer">
                <el-button @click="configSkillDialog = false">Close</el-button>
                <el-button  type="primary" :loading="submitAopeSkillLoading" @click="submitAopeSkill">Save</el-button>
            </span>
        </el-dialog>


        <skill-dialog ref="reportDialog" :report="report"></skill-dialog>
        <a id="generate-link"></a>

    </div>
</template>

<script>
    import Cookies from 'js-cookie'
    import md5 from '../../component/md5'
    import SkillDialog from '../common/ReportDialog.vue'
    import axios from 'axios'


    export default {

        components: {
            'skill-dialog': SkillDialog
        },

        data() {
            //修改用户信息密码自动验证
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Password Required'));
                } else {
                    if (this.editform.EconfirmPassword !== '') {
                        this.$refs.editform.validateField('EconfirmPassword');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('ConfirmPassword Required'));
                } else if (value !== this.editform.Epassword) {
                    callback(new Error('Passwords do not match!'));
                } else {
                    callback();
                }
            };
            return {
                teacherId: 0,
                teacherName: '',
                studentId: 0,
                loading:false,
                loadingText: 'loading...',
                // Dialog 保存按钮loading变量
                saveBtnIsLoading: false,

                //表格信息
                MyStudents: [],
                stuCountList:[],

                //分页信息
                currentPageTable: 1,
                totalPages: 1,
                size: 15,
                //搜索栏
                selectTripValue:'',
                dialogtripid:'',
                options: [{
                    id: 0,
                    name: ''
                }],
                keywords:'',

                //修改信息弹窗
                Editdialog: false,
                editform: {
                    EDeadline2:'',
                    EDeadline1:'',
                },
                isDirty: false,//判断有无修改弹窗
                isTripDirty:false,
                dialogtripvalue: '',
                checked: false,//修改弹窗修密码框是否显示
                willshow: false,//修改弹窗修密码框是否显示
                pickerOptions: {//修改弹窗deadline
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                editrules: {
                    Eemail: [
                        {required: true, message: 'Email Adress Required', trigger: 'blur'},
                        {type: 'email', message: 'Email format invalid.'},
                    ],
                    Epassword: [
                        {required: true, message: 'Password Required', trigger: 'blur'},
                        {validator: validatePass, trigger: 'blur'},
                        {min: 8, max: 20, message: 'Password should contain 8 to 20 characters.', trigger: 'blur'},
                        {pattern: /^\w{8,20}$/, message: "Only numbers, letters, and underscores allowed.", trigger: 'blur'}
                    ],
                    EconfirmPassword: [
                        {required: true, message: 'Confirm Password Required', trigger: 'blur'},
                        {validator: validatePass2, trigger: 'blur'}
                    ],
                    EgivenName: [
                        {required: true, message: 'GivenName Required', trigger: 'blur'},
                        {max: 30, message: 'givenName should not more than 30 characters.', trigger: 'blur'}
                    ],
                    EfamilyName: [
                        {required: true, message: 'FamilyName Required', trigger: 'blur'},
                        {max: 30, message: 'familyName should not more tha 30 characters.', trigger: 'blur'}
                    ],
                    EdisplayName: [
                        {required: true, message: 'DisplayName Required', trigger: 'blur'},
                        {max: 60, message: 'displayName should not more tha 60 characters.', trigger: 'blur'}
                    ],
                    Eschool: [
                        {required: true, message: 'Affiliation Required', trigger: 'blur'},
                        {max: 100, message: 'Affiliation Name should not more tha 100 characters.', trigger: 'blur'}
                    ],
                    EmobilePhone: [
                        {required: false,},
                        {pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur'}
                    ],
                    EmotherPhone: [
                        {required: false,},
                        {pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur'}
                    ],
                    EfatherPhone: [
                        {required: false,},
                        {pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur'}
                    ]
                },

                //显示报告详情
                report: {},
                reportId:0,//传递参数用
                userId: 0,

                // cope、aope技能顺序
                copeItems : ['IOLP', 'WWO', 'PS', 'D', 'R', 'OP'],
                aopeItems: ['PRL','TW', 'TP', 'RS', 'ISP','LWE','CE'],

                //下载报告弹窗dialog用
                student:{},
                showReportDialog: false,
                reportDialogParam:{assessor:'', moderator: '', filled: false, category:''},

                //配置学生AOPE技能弹窗
                submitAopeSkillLoading:false,
                configSkillDialogLoading:false,
                configSkillDialog:false,
                configSkillTitle:'',
                checkedSkillsId:[],
                checkedSkillsName:[],
                allAopeSkills:[],
                expandRowKeys:[],
                queryStudentId:''
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                this.init();
                this.getTeacherInfo();
                this.getTrip();
                this.getMyStudents();
            })
        },
        methods:{
            init: function () {
                this.teacherId = Cookies.get('teacherId');
                this.role = Cookies.get('role');
                this.userId = Cookies.get('userid');
                if (this.$route.query.studentId !== undefined) {
                  this.queryStudentId = this.$route.query.studentId
                }
            },

            //获取trip列表
            getTrip(){
                this.$http.get('trip/list').then(response => {
                    this.options = response;
                }).catch(error => {
                    this.$message.error(error.message)
                })
            },
            showTripList(){
                this.getTrip()
            },

            //获取老师信息
            getTeacherInfo: function () {
                this.$http.get('teacher/'+ this.teacherId).then(res => {
                    this.teacherName = res.familyName + ' ' + res.givenName;
                }).catch(error => {
                    this.$message.error(error.message);
                });
            },

            //获取我的所有学生列表
            getMyStudents () {
                this.loading = true;
                this.$http.get('relation',{params:{
                    teacherId: this.teacherId,
                    size:this.size,
                    page:(this.currentPageTable - 1),
                    tripId:this.selectTripValue,
                    keywords:this.keywords,
                    except:false,
                }
                }).then(response => {
                    this.MyStudents = response.list;
                    var stuCountList = new Array();
                    for(var i=0; i< response.list.length; i++){
                        this.MyStudents[i].report = {
                            id:0,
                            skillList:[
                                {
                                    abbr:'',
                                    enabled:false,
                                    id:0,
                                    pageList:[
                                        {
                                            confirmed:false,
                                            page:'',
                                            id:0
                                        }
                                    ]
                                }
                            ]
                        };
                        this.MyStudents[i].reportC = {
                            id:0,
                            skillList:[
                                {
                                    abbr:'',
                                    enabled:false,
                                    id:0,
                                    pageList:[
                                        {
                                            confirmed:false,
                                            page:'',
                                            id:0
                                        }
                                    ]
                                }
                            ]
                        };
                        this.$set(this.MyStudents[i],'loadingReport', true);
                        stuCountList.push(this.MyStudents[i].userId)
                    }

                    this.totalPages = response.totalPages;
                    this.loading = false;
                    //获取各学生未读notification数
                    if(this.role ==='teacher' || this.role === 'ta'){
                        this.$http.post('notification/count/list',stuCountList).then(response => {
                            for(var i=0; i<response.length; i++){
                                this.$set(this.MyStudents[i],'notificationCount', response[i]);
                            }
                        }).catch(error => {
                            this.$message.error(error.message)
                        })
                    }
                    if (this.queryStudentId !== '') {
                      let studentIndex = 0;
                      this.MyStudents.forEach((student, index) => {
                        if (student.id == this.queryStudentId) {
                          studentIndex = index;
                        }
                      })
                      this.expandRowKeys.push(this.queryStudentId)
                      this.getStuReport({index:'0'}, studentIndex, {id: this.queryStudentId})
                    }
                }).catch(error => {
                    this.$message.error(error.message),
                        this.loading = false;
                })
            },

            downloadFile(blob, fileName, aLinkId) {
                // 能力检测
                // IE独家秘笈 => navigator.msSaveBlob
                if(window.navigator.msSaveBlob){
                    // for ie 10 and later
                    try {
                        window.navigator.msSaveBlob(blob, fileName);
                    } catch(e) {
                        console.log(e);
                    }
                } else {
                    try {
                        let aLink = document.getElementById(aLinkId);
                        aLink.download = fileName;
                        aLink.href = window.URL.createObjectURL(blob);
                        aLink.click();
                        window.URL.revokeObjectURL(blob);
                    } catch(e) {
                        console.log(e);
                    }
                }
            },

            download:function (student) {
                this.loading = true;
                let fileName =  student.displayName +'_'+ student.givenName +'_'+ student.familyName +'.pdf';
                axios.instance().get('report/download',{params:{studentId: student.id},responseType:'blob'}).then(response =>{
                    let blob = response.data;
                    let aLinkId = 'generate-link';
                    // 下载文件，传递三个参数，blob对象，文件名，a标签id
                    this.downloadFile(blob, fileName, aLinkId)
                    this.loading = false;
                    this.loadingText = 'loading...';
                }).catch(error =>{
                    this.loading = false;
                    this.loadingText = 'loading...';
                    console.log(error)
                    this.$message.error('Service unavailable, please try again later.');
                });
            },

            downloadDocx:function (student) {
              this.loading = true;
              let fileName =  student.displayName +'_'+ student.givenName +'_'+ student.familyName +'.docx';
              axios.instance().get('report/downloadDocx',{params:{studentId: student.id},responseType:'blob'}).then(response =>{
                let blob = response.data;
                let aLinkId = 'generate-link';
                // 下载文件，传递三个参数，blob对象，文件名，a标签id
                this.downloadFile(blob, fileName, aLinkId)
                this.loading = false;
                this.loadingText = 'loading...';
              }).catch(error =>{
                this.loading = false;
                this.loadingText = 'loading...';
                console.log(error)
                this.$message.error('Service unavailable, please try again later.');
              });
            },
            preview(student) {
              window.open('/api/report/html?category=epq&studentId=' + student.id)
            },

            //改变当前页函数
            pageCurrentChange(val){
                this.currentPageTable = val;
                this.getMyStudents();
            },

            //输关键字搜索
            handleIconClick(){
                this.loading = true;
                this.getMyStudents();
            },

            //选trip搜索
            tripSelectList(){
                this.getMyStudents();
            },

            //获取弹窗信息
            Editstudent(user){
                this.id = user.id;
                this.$set(this.editform,'EmotherPhone', user.motherPhone);
                this.$set(this.editform,'EfatherPhone', user.fatherPhone);
                this.$set(this.editform,'Eschool',user.school);
                this.dialogtripid = user.tripId;
                this.$set(this.editform,'EdisplayName',user.displayName);
                this.$set(this.editform,'EfamilyName',user.familyName);
                this.$set(this.editform,'EgivenName',user.givenName);
                this.$set(this.editform,'Eemail',user.email);
                this.$set(this.editform,'EmobilePhone',user.mobilePhone);
                this.$set(this.editform,'EDeadline1',user.deadline1);
                this.$set(this.editform,'EDeadline2',user.deadline2);
                this.Editdialog = true;
                this.Editdialog = true;
                this.checked = false;
                this.willshow = false;
            },

            //给学生修改trip
            ChangeTrip(){
//                console.log('TripDirty:'+ this.isTripDirty)
                if(this.isTripDirty){
                    this.$http.put('trip/choose?studentId='+ this.id +'&tripId=' + this.dialogtripid).then(response => {
                        this.getMyStudents();
                        this.Editdialog = false;
                    }).catch(error => {
                        this.$message.error(error.message);
                        this.getMyStudents();
                        this.Editdialog = false;
                    })
                }else{
                    this.getMyStudents();
                    this.Editdialog = false;
                }

                this.isTripDirty = false;

            },

            //编辑学生
            changePass(){
                if(this.checked ==true){
                    this.willshow =true;
                    this.isDirty = true;
                }else {
                    this.willshow =false;
                }
            },
            submitedit(formName) {
//                console.log('TripDirty:'+ this.isTripDirty)
//                console.log('Dirty:'+ this.isDirty)
                if(!this.isDirty && !this.isTripDirty){
                    this.Editdialog = false;
                    return;
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        // 触发save按钮事件，按钮进入loading状态
                        this.saveBtnIsLoading = true;
                        var api = {
                            email: this.editform.Eemail,
                            familyName: this.editform.EfamilyName,
                            givenName: this.editform.EgivenName,
                            displayName: this.editform.EdisplayName,
                            mobilePhone: this.editform.EmobilePhone,
                        };
                        if(this.checked == true){
                            var EPwd_md5 = md5.hex_md5(this.editform.Epassword);
                            api.password = EPwd_md5;
                        }
                        this.$http.put('student', {
                            id: this.id,
                            motherPhone: this.editform.EmotherPhone,
                            fatherPhone: this.editform.EfatherPhone,
                            school: this.editform.Eschool,
                            deadline1: this.editform.EDeadline1,
                            deadline2: this.editform.EDeadline2,
                            user: api
                        }).then(response => {
                            this.ChangeTrip();
                            this.loading = true;
                            api.password = undefined
//                            this.getMyStudents();
                            this.saveBtnIsLoading = false;
                        }).catch(error => {
                            this.loading = false;
                            this.Editdialog = false;
                            this.saveBtnIsLoading = false;
                            this.$message.error(error.message)
                        })

                    } else {
                        return false;
                    }
                });
                this.isDirty = false;
            },

            // 将copo和aope数据排序
            customSort(list, items) {
                var newSkillList = [];
                list.forEach(value => {
                    var abbr = value['abbr'];
                    /*abbr === 'IOLP' ? newSkillList[0] = value :
                     (abbr === 'WWO' ? newSkillList[1] = value :
                     (abbr === 'PS' ? newSkillList[2] = value :
                     (abbr === 'D' ? newSkillList[3] = value :
                     (abbr === 'R' ? newSkillList[4] = value :
                     (abbr === 'OP' ? newSkillList[5] = value : '')))));*/
                    items.forEach((item, itemIndex) => {
                        abbr === item ? newSkillList[itemIndex] = value : '';
                    })
                })
                return newSkillList;
            },

            //获取学生报告信息
            getPortfolio(index,studentId,category){
                this.$set(this.MyStudents[index],'loadingReport', true)
                this.$http.get('report',{params:{
                    studentId: studentId,
                    category:category
                }
                }).then(response => {
                    if(category === 'epq'){
                        // response.skillList = this.customSort(response.skillList, this.copeItems);
                        this.MyStudents[index].reportC = response;
                    } else {
                        // response.skillList = this.customSort(response.skillList, this.aopeItems);
                        this.MyStudents[index].report = response;
                    }
                    this.$set(this.MyStudents[index],'loadingReport', false)
                    this.studentId = studentId;
                }).catch(error => {
                    this.$message.error(error.message);
                })
            },

            //展开行
            getExpand(row, expandedRows){
                let _this = this;
                expandedRows.forEach(function (pro) {
                    if(row.id === pro.id){//判断当前点击的行是否在expendedRows中，即当前行点击是展开还是关闭，如果展开则往下走
                        let myStudents = _this.MyStudents;
                        myStudents.forEach(function (p,index) {
                            if(p.id === row.id){
                                _this.getPortfolio(index, row.id, 'epq')
                            }
                        })
                    }
                });
            },
            getStuReport(ev, index, student){//点击不同tab(tab实例，行数，studentid)
                if(ev.index === '1'){
                    this.getPortfolio(index,student.id,'log');
                }else {
                    this.getPortfolio(index,student.id,'epq')
                }

            },


            /*表格点击时需要传递四个参数，用index来获取reportid，故调用*/
            showPage: function (skill, page, pageId,index,category) {
                if(category === 'log'){
                    this.report.id = this.MyStudents[index].report.id;
                }else {
                    this.report.id = this.MyStudents[index].reportC.id;
                }
                this.$refs.reportDialog.showDialogFromTeacher(this.report, skill, page, pageId,{id: this.MyStudents[index].id, displayName: (this.MyStudents[index].displayName + ' - ' + this.MyStudents[index].givenName + '  ' +  this.MyStudents[index].familyName)});
            },

            /* 下载报告dialog用 */

            //将Assessor填充为老师的英文名
            getCurrentUserName: function () {
                this.reportDialogParam.assessor = this.teacherName;
            },

            showDownloadReportDialog: function (event, student, category) {
                this.student = student;
                this.reportDialogParam = {assessor:'', moderator: '', filled: false, category: category};
                this.reportDialogParam = {assessor:'', moderator: '', filled: false, category: category};
                this.showReportDialog = true;
            },


            //配置AOPE skill技能
            editAopeSkill(user,index){
                this.configSkillTitle = 'Edit AoPE Skills For '+ user.displayName + user.givenName +' '+ user.familyName;
                this.configSkillDialog = true;
                this.configSkillDialogLoading = true;
                this.$http.get('report',{params:{
                    studentId: user.id,
                    category:'aope'
                }
                }).then(response => {
                    response.skillList = this.customSort(response.skillList, this.aopeItems);
                    this.MyStudents[index].report = response;//拿到aope所有技能
                    let checkedSkillsName =[]
                    let checkedSkillsId =[]
                    //拿到已选择的aope技能
                    this.MyStudents[index].report.skillList.forEach(function (ckeckedSkill) {
                        if(ckeckedSkill.enabled){
                            checkedSkillsName.push(ckeckedSkill.name)
                            checkedSkillsId.push({id :ckeckedSkill.id})
                        }
                    })
                    this.reportId = response.id
                    this.allAopeSkills= response.skillList
                    this.checkedSkillsName = checkedSkillsName
                    this.checkedSkillsId = checkedSkillsId
                    this.configSkillDialogLoading = false;
                }).catch(error => {
                    this.$message.error(error.message);
                })
            },
            changeCheckedSkill(el){
                let p = []
                let allSkills = this.allAopeSkills
                el.forEach(function (val) {
                    allSkills.forEach(function (pro) {
                        if(val === pro.name){
                            p.push({id :pro.id})
                        }
                    })
                })
                this.checkedSkillsId = p;
            },
            submitAopeSkill(){
                if(this.checkedSkillsId.length > 3){
                    this.$message.warning('You can only choose 3 skills.')
                }else if(this.checkedSkillsId.length < 3) {
                    this.$message.warning('Please choose 3 skills.')
                }else{
                    this.submitAopeSkillLoading = true;
                    let parms = {
                        id : this.reportId,
                        skillList : this.checkedSkillsId
                    };
                    this.$http.post('report/assignSkill', parms).then(response => {
                        this.submitAopeSkillLoading = false;
                        this.configSkillDialog = false;
                        this.getMyStudents();
                    }).catch(error => {
                        this.$message.error(error.message);
                    })
                }
            },
            getRowKey: function (row) {
              return row.id;
            }


        }

    }
</script>

<style lang="scss" scope>
    @import "../../css/variable";
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 65px;
        color: #99a9bf;
    }
    .demo-table-expand .log label {
        width: 160px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .el-badge__content.is-fixed {
        top: 8px;
        right: 0px;
        cursor: pointer;
    }

    .el-form-item{
        i{
            font-size: 16px;
            &:hover{
                cursor: pointer;
            }
            &.icon-folder{
                font-size: 18px;
            }
        }
        i.ion-shuffle{
            font-size: 12px;
        }
        .p-evidence{
            padding: 3.5px 5px !important;
        }

        .pt-7{
            padding-top: 7px;
        }

    }
    //报告页
    .question-title {
        display: table;
    }

    .owner {
        position: absolute;
        top: -68px;
        right: 40px;
    }

    //configAope弹窗
    .configAope{
        display: table-caption;
        & .el-checkbox:first-child{
            margin-left: 30px;
        }
    }
</style>


// WEBPACK FOOTER //
// Progress.vue?332b0059